// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__v4fZq","person":"Avatar_person__-fYbX","entity":"Avatar_entity__1ETSf"};